import { DateTime } from 'luxon'
import { IntlShape } from 'react-intl'
import { ParkingEventDTO } from '../apis/parkingEvents/dto'

export namespace BackendDatetime {
  export const nowToUTC = (): string => {
    return toUTC(DateTime.local())
  }
  export const toUTC = (datetime: DateTime): string => {
    if (!datetime.isValid) {
      console.error('Invalid datetime was given. ', datetime)
      return ''
    }
    return datetime.toUTC().toISO() || ''
  }
  export const fromUTC = (
    utcDatetime: string | undefined,
    locale: string,
  ): DateTime => {
    return DateTime.fromISO(utcDatetime || '').setLocale(locale)
  }
}

export namespace UIDatetime {
  export const toString = (datetime: DateTime): string => {
    return datetime.toLocaleString(DateTime.DATETIME_SHORT)
  }
}

export namespace UIDate {
  export const toString = (datetime: DateTime): string => {
    return datetime.toLocaleString(DateTime.DATE_SHORT)
  }

  export const toCustomString = (
    datetime: DateTime,
    format: string = 'yyyyMMdd',
  ): string => {
    return datetime.toFormat(format)
  }
}

export const prettyFullTimestamp = (
  intl: IntlShape,
  isoTimestamp: string | undefined | null,
) => {
  if (!isoTimestamp) return ''
  const dateStr = intl.formatDate(isoTimestamp)
  const timeStr = intl.formatTime(isoTimestamp, {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  })
  return `${dateStr} ${timeStr}`
}

export const prettyDuration = (
  intl: IntlShape,
  parkingEvent: ParkingEventDTO,
) => {
  if (!parkingEvent.duration && parkingEvent.duration !== 0) return ''
  const hours = Math.floor(parkingEvent.duration / (60 * 60))
  const minutes = Math.floor(parkingEvent.duration / 60) % 60
  const seconds = parkingEvent.duration % 60
  const hourUnit = intl.formatMessage({ id: 'common.units.hours.short' })
  const minuteUnit = intl.formatMessage({ id: 'common.units.minutes.short' })
  const secondUnit = intl.formatMessage({ id: 'common.units.seconds.short' })
  const nbsp = '\u00A0'
  if (hours === 0 && minutes === 0) return `${seconds}${nbsp}${secondUnit}`
  if (hours === 0)
    return `${minutes}${nbsp}${minuteUnit} ${seconds}${nbsp}${secondUnit}`
  return `${hours}${nbsp}${hourUnit} ${minutes}${nbsp}${minuteUnit} ${seconds}${nbsp}${secondUnit}`
}
